import { IP360PartnerFlags } from 'partner360/models/p360PartnerFlags/IP360PartnerFlags'

import { IPreparedTopPartner } from '../models'

import { getFlagRequestDirection } from './getFlagRequestDirection'
import { getMarketCoverage } from './getMarketCoverage'
import { isActiveFlagRequest } from './isActiveFlagRequest'

export const sumPendingAddCoverage = (partners: IPreparedTopPartner[], flag: IP360PartnerFlags) => {
  const values = partners
    .filter(
      (partner) =>
        isActiveFlagRequest(partner.RequestStatus) &&
        getFlagRequestDirection(partner, flag) === 'added'
    )
    .map((partner) => getMarketCoverage(partner.Coverage, flag))
    .filter((value): value is number => value !== null)

  if (!values.length) {
    return null
  }

  return values.reduce<number>((sum, value) => sum + value, 0)
}
